import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';

const Privacy = () => {
    return (
        <>
            <SEO
                title="Privatumo politika – SmartPanda"
                description="SmartPanda privatumo politika. Sužinokite, kaip tvarkomi vartotojų, vaikų profilių, techniniai ir kiti asmens duomenys bei kaip užtikrinama jų apsauga."
                canonical="/privatumas"
            />

            <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">

                    <div className="text-center mb-12">

                        <Link
                            to="/"
                            className="inline-block mb-4 text-pink-600 font-bold hover:underline"
                        >
                            ← Grįžti į pradžią
                        </Link>

                        <h1 className="text-4xl font-bold text-gray-900">
                            Privatumo politika
                        </h1>

                        <p className="text-gray-500 mt-2 italic">
                            Paskutinį kartą atnaujinta: 2026 m. balandžio 21 d.
                        </p>
                    </div>

                    <div className="bg-white rounded-3xl shadow-xl p-10 prose prose-pink max-w-none text-gray-700">

                        <p className="lead text-lg mb-8">
                            „SmartPanda“ gerbiame jūsų privatumą ir esame
                            įsipareigoję saugoti jūsų asmens duomenis.
                            Ši privatumo politika paaiškina, kaip mes
                            renkame, naudojame ir saugome jūsų informaciją.
                        </p>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                1. Kokius duomenis mes renkame?
                            </h2>

                            <ul className="list-disc pl-6 space-y-2 mt-4">
                                <li>
                                    <strong>Identifikavimo duomenys:</strong>{' '}
                                    Vardas, pavardė, el. pašto adresas.
                                </li>

                                <li>
                                    <strong>Vaikų duomenys:</strong>{' '}
                                    Tik pseudonimai (jei nurodyta) ir jų
                                    amžius, siekiant pritaikyti AI turinį.
                                </li>

                                <li>
                                    <strong>Techniniai duomenys:</strong>{' '}
                                    IP adresas, naršyklės tipas, naudojimosi
                                    platforma istorija.
                                </li>

                                <li>
                                    <strong>Mokėjimo informacija:</strong>{' '}
                                    Saugomai tvarkoma tik per trečiųjų šalių
                                    mokėjimo sistemas (pvz., Stripe).
                                </li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                2. Kaip mes naudojame jūsų duomenis?
                            </h2>

                            <ul className="list-disc pl-6 space-y-2 mt-4">
                                <li>
                                    Paslaugų teikimui ir personalizavimui
                                    naudojant AI.
                                </li>

                                <li>
                                    Sąskaitų išrašymui ir prenumeratų
                                    valdymui.
                                </li>

                                <li>
                                    Saugumo užtikrinimui ir sukčiavimo
                                    prevencijai.
                                </li>

                                <li>
                                    Komunikacijai apie svarbius
                                    atnaujinimus.
                                </li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                3. Duomenų saugojimas ir BDAR
                            </h2>

                            <p>
                                Mes laikomės Bendrojo duomenų apsaugos
                                reglamento (BDAR) reikalavimų. Jūs turite
                                teisę susipažinti su savo duomenimis,
                                prašyti juos ištaisyti arba ištrinti.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                4. Slapukai (Cookies)
                            </h2>

                            <p>
                                Savo svetainėje naudojame būtinus slapukus,
                                užtikrinančius svetainės veikimą, ir
                                analitinius slapukus, padedančius mums
                                tobulinti vartotojo patirtį. Jūs galite
                                valdyti slapukų nustatymus per savo naršyklę
                                arba mūsų slapukų pranešimo juostą.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                                5. Susisiekite
                            </h2>

                            <p>
                                Jei turite klausimų dėl duomenų apsaugos,
                                kreipkitės el. paštu:{' '}
                                info@korepetitorius.eu
                            </p>
                        </section>

                    </div>

                    <div className="mt-12 text-center text-gray-500 text-sm">
                        <p>
                            © 2026 SmartPanda. Saugome jūsų privatumą.
                        </p>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Privacy;
